
import { RoutePermittedRole } from "shared/constants/AppConst";
import Transaction from "./transaction_page";
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const transactionConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/transaction",
    exact: true,
    element: isModuleAuthorized("Manage Transaction") ? <Transaction /> : <Error403 />,
  }
];


